import { render, staticRenderFns } from "./SideTask.vue?vue&type=template&id=66b688f4&"
import script from "./SideTask.vue?vue&type=script&lang=js&"
export * from "./SideTask.vue?vue&type=script&lang=js&"
import style0 from "./SideTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports